"use client";

// `<html data-hydrated>` once the page the server rendered has hydrated. The e2e specs wait for it
// before interacting: server-rendered forms submit natively until then, reloading the page, and
// React drops clicks on content it can't hydrate yet.
//
// The root sets it after its first commit, unless the page has server component content (docs,
// blog, policy and landing pages). TanStack Start decodes that content when React first renders it,
// so it hydrates in a later commit of its own; until then it is still server HTML. Its server
// functions wrap it with `withHydrationMarker` (src/lib/ServerContent.tsx), which adds
// `ServerContentHydrated`: a `<meta>` (React hoists it into the head, so the root sees it from the
// first byte) that marks the document hydrated when the content commits. The development-only
// brand and marketing kits render it too (KitShell): their page components load lazily, so they
// also hydrate after the root.
import { useEffect } from "react";
import { markHydrated, SERVER_CONTENT_META } from "./DocumentHydrationMarker";

/** Marks the document hydrated once the server component content it ends has hydrated. */
export const ServerContentHydrated = () => {
  useEffect(markHydrated, []);
  return <meta name={SERVER_CONTENT_META} content="" />;
};
